import React from 'react';

const BooleanToStringRenderer = <TItem extends { [key: string]: any }>({
    item,
    colKey,
}: {
    item: TItem;
    colKey: string;
}): JSX.Element => {
    return <>{`${item[colKey] === true ? 'YES' : 'NO'}`}</>;
};

export default BooleanToStringRenderer;
